<template>
    <v-dialog v-model="dialog" max-width="500px">
        <v-btn
            slot="activator"
            color="primary"
            dark>
            Add Multiple Vehicle/s
        </v-btn>
        <v-card>
          <v-card-title>
            <span class="headline">New Vehicles</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-form ref="newVehicle" v-model="newVehicleValid">
                      <v-autocomplete v-model="customer" :items="customerList" :loading="gettingCustomers" label="Select a Customer" item-text="name"
                     item-value="key" required :rules="[v => !!v || 'Customer is required']" :disabled="customerFixed">
                  </v-autocomplete>
                    <v-text-field 
                        label="Quantity" 
                        v-model="quantity"
                        :rules="[v => !!v || 'Quantity is required', v => v > 0 || 'Quantity must be greater than 0']" 
                        required
                        type="number">
                    </v-text-field>
                    <v-combobox
                        label="Make"
                        v-model="makeSelect"
                        :items="vehicleMakes"
                        item-text="name"
                        item-value="key"
                        clearable></v-combobox>
                    <v-combobox
                        label="Model"
                        v-model="modelSelect"
                        :items="modelList"
                        item-text="name"
                        item-value="key"
                        :loading="gettingModels"
                        clearable></v-combobox>
                    <v-text-field
                        label="Year"
                        v-model="Year"
                        type="number"
                        mask="####"></v-text-field>
                    <v-autocomplete
                        label="Site"
                        v-model="Site"
                        :items="sites"
                        item-text="name"
                        :rules="[v => !!v || 'Site is required']"
                        item-value="key"
                        append-outer-icon="mdi-plus"
                        @click:append-outer="siteDialog = true"></v-autocomplete>
                    <v-dialog v-model="siteDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                        <v-card>
                          <v-toolbar dark color="primary">
                            <v-btn icon dark @click="siteDialog = false">
                              <v-icon>close</v-icon>
                            </v-btn>
                            <v-toolbar-title>Sites</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-toolbar-items>
                              <v-btn dark flat @click="siteDialog = false">Save</v-btn>
                            </v-toolbar-items>
                          </v-toolbar>
                          <v-layout>
                            <sites-view v-if="siteDialog"/>
                          </v-layout>
                        </v-card>
                      </v-dialog>
                  </v-form>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click.native="close">Cancel</v-btn>
            <v-btn color="blue darken-1" flat @click.native="save" :disabled="!newVehicleValid">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
</template>

<script>
import { fireStore } from '../../firebase'
export default {
  props: ['parentCustomer', 'customerFixed'],
  data () {
    return {
      siteDialog: false,
      newVehicleValid: false,
      gettingModels: false,
      vehicleMakes: [],
      makeSelect: null,
      modelSelect: null,
      Year: null,
      Site: null,
      vehicles: [],
      vehicleModels: {},
      modelList: [],
      sites: [],
      dialog: false,
      dialogOpened: 0,
      quantity: 1,
      gettingCustomers: false,
      customerList: [],
      customer: null
    }
  },
  created () {
    this.getCustomers()
  },
  mounted () {
    this.getVehicles()
    this.sites = []
    this.customer = this.parentCustomer
    this.quantity = 1
  },
  watch: {
    parentCustomer: function (val) {
      this.customer = val
    },
    makeSelect: function (val) {
      if (this.dialogOpened === 0) {
        this.modelSelect = null
      } else {
        this.dialogOpened = 0
      }
      if (val !== null && val !== undefined && val !== '') {
        // this.editedItem.Model = null
        this.getModels()
      }
    },
    customer: function (val) {
      if (val) {
        this.getSites()
        this.Site = null
      }
    },
    siteDialog: function (val) {
      if (!val) {
        this.getSites()
      }
    }
  },
  methods: {
    getCustomers () {
      this.gettingCustomers = true
      fireStore.collection('Customers').get()
      .then(snap => {
        snap.forEach(doc => {
          this.customerList.push({key: doc.id, name: doc.data().customerName, shortName: doc.data().shortName})
        })
        this.customerList.sort(function (a, b) {
          const aName = a.name.toLowerCase()
          const bName = b.name.toLowerCase()
          return aName < bName ? -1 : aName > bName ? 1 : 0
        })
        this.gettingCustomers = false
      })
    },
    getSites () {
      this.sites = []
      fireStore.collection('Sites').where('Customer', '==', this.customer)
      .get()
      .then(snap => {
        snap.forEach(doc => {
          this.sites.push({key: doc.id, name: doc.data().Name})
        })
      })
    },
    getModels () {
      this.modelList = []
      this.gettingModels = true
      if (this.makeSelect !== undefined && this.makeSelect !== null) {
        this.modelList = this.vehicleModels[this.makeSelect]
      }
      this.gettingModels = false
    },
    getVehicles () {
      this.vehicles = []
      fireStore.collection('Vehicles')
      .get()
      .then(snap => {
        snap.forEach(doc => {
          let data = doc.data()
          data.id = doc.id
          this.vehicles.push(data)
          if (this.vehicleMakes.includes(data.Make) === false && data.Make !== undefined) {
            this.vehicleMakes.push(data.Make)
          }
          if (((this.vehicleModels[data.Make] && this.vehicleModels[data.Make].includes(data.Model) === false) || this.vehicleModels[data.Make] === undefined) && data.Model !== undefined && data.Make !== undefined) {
            if (this.vehicleModels[data.Make] === undefined) {
              this.vehicleModels[data.Make] = []
            }
            if (data.Model) {
              this.vehicleModels[data.Make].push(data.Model)
            }
          }
        })
      })
    },
    close () {
    //   this.$emit('update:dialog', false)
      this.dialog = false
      setTimeout(() => {
        this.makeSelect = null
        this.modelSelect = null
        this.Year = null
        this.Site = null
        this.quantity = 1
        this.sites = []
      }, 300)
    },
    save () {
      let vehiclesArr = []
      let i = 0
      let promises = []
      fireStore.collection('Vehicles').get()
      .then(snap => {
        let vehicleFriendlyIds = ['0']
        snap.forEach(doc => {
          const data = doc.data()
          if (data.friendlyId) {
            if (data.friendlyId.indexOf('CUBO') > -1 && data.friendlyId.indexOf('NaN') === -1) {
              let number = data.friendlyId.replace('CUBO', '')
              if (!isNaN(number)) {
                vehicleFriendlyIds.push(parseInt(number))
              }
            }
          }
        })
        vehicleFriendlyIds.sort(function (a, b) {
          return a - b
        }).reverse()
        let friendlyId = vehicleFriendlyIds[0]

        for (i = 0; i < this.quantity; i++) {
          promises[i] = new Promise((resolve, reject) => {
            let obj = {
              Customer: this.customer
            }
            if (this.makeSelect) {
              obj.Make = this.makeSelect
            }
            if (this.modelSelect) {
              obj.Model = this.modelSelect
            }
            if (this.Year) {
              obj.Year = this.Year
            }
            if (this.Site) {
              obj.Site = this.Site
            }
            friendlyId = this.zeroFill((parseInt(friendlyId) + 1), 5)
            obj.friendlyId = 'CUBO' + friendlyId
            obj.vehReg = obj.friendlyId
            obj.Added = Date.now()
            fireStore.collection('Vehicles').add(obj)
            .then(docRef => {
              obj.id = docRef.id
              vehiclesArr.push(obj)
              resolve()
            })
            .catch(error => {
              reject(error)
            })
          })
        }
        Promise.all(promises)
        .then(result => {
          this.$emit('vehiclesAdded', vehiclesArr)
          this.close()
        })
      })
    },
    zeroFill (number, width) {
      width -= number.toString().length
      if (width > 0) {
        return new Array(width + (/\./.test(number) ? 2 : 1)).join('0') + number
      }
      return number
    }
  }
}
</script>



// WEBPACK FOOTER //
// MultiVehicleDialog.vue?26cf3026